<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <cms-block-renderer v-for="child in block.children" :key="child.id" @block-selected="selectBlock" :block="child" :block-selection="blockSelection"
                            :parent="block" :editable="editable"/>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-column #hot-reload-debug
export default {
    name: `cms-block-column`,
    components: {
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock
}
</script>

<style lang="scss" scoped>
</style>
